/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedPersonNameDTO } from './ReferencedPersonNameDTO';
import {
    ReferencedPersonNameDTOFromJSON,
    ReferencedPersonNameDTOFromJSONTyped,
    ReferencedPersonNameDTOToJSON,
    ReferencedPersonNameDTOToJSONTyped,
} from './ReferencedPersonNameDTO';
import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface WorkPersonDTO
 */
export interface WorkPersonDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkPersonDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPersonDTO
     */
    affiliation?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPersonDTO
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkPersonDTO
     */
    sequence?: number;
    /**
     * 
     * @type {ReferencedPersonNameDTO}
     * @memberof WorkPersonDTO
     */
    personName?: ReferencedPersonNameDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkPersonDTO
     */
    topOrgas?: Array<string>;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof WorkPersonDTO
     */
    externalIds?: Array<ExternalIdDTO>;
}

/**
 * Check if a given object implements the WorkPersonDTO interface.
 */
export function instanceOfWorkPersonDTO(value: object): value is WorkPersonDTO {
    return true;
}

export function WorkPersonDTOFromJSON(json: any): WorkPersonDTO {
    return WorkPersonDTOFromJSONTyped(json, false);
}

export function WorkPersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPersonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'affiliation': json['affiliation'] == null ? undefined : json['affiliation'],
                  'role': json['role'] == null ? undefined : json['role'],
                  'sequence': json['sequence'] == null ? undefined : json['sequence'],
                  'personName': json['personName'] == null ? undefined : ReferencedPersonNameDTOFromJSON(json['personName']),
              'topOrgas': json['topOrgas'] == null ? undefined : json['topOrgas'],
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
    };
}

export function WorkPersonDTOToJSON(json: any): WorkPersonDTO {
    return WorkPersonDTOToJSONTyped(json, false);
}

export function WorkPersonDTOToJSONTyped(value?: WorkPersonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'affiliation': value['affiliation'],
        'role': value['role'],
        'sequence': value['sequence'],
        'personName': ReferencedPersonNameDTOToJSON(value['personName']),
        'topOrgas': value['topOrgas'] == null? value['topOrgas']: value['topOrgas'],
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
    };
}


